import { useState } from 'react';
import { IconType } from '../../types/icon.type';
import { getSubComponent } from '../../utils/react.utils';
import Container from '../containers/container';
import Icon from '../icons/icon';

const styles = {
  container: 'w-full',
  'tab-list': 'w-full grid grid-cols-[4fr_1fr] min-h-[2.5rem]',
  'tab-list-text-container': 'self-center',
  'tab-list-icon-container':
    'flex flex-1 w-full h-full items-center justify-end',
  border: 'border-b-[6px] border-accent w-[2.5rem] pt-0.5',
  'tab-list-wrapper': 'w-full sticky bg-[#08080D] z-30 pb-2',
  heading: 'font-text text-lg capitalize font-medium text-primary',
};

type Props = {
  state: string[]; // two strings - names for tabs
  icons: IconType[]; // two icon type elements - icons to be rendered
  children: any; // Two react children elements
  className?: string;
};

function IconTab({ state, icons, children, className }: Props) {
  const [current, set] = useState(0);

  const Content = getSubComponent<'Content'>(children, 'Content');

  const toggle = () => {
    set((prev) => (prev === 1 ? 0 : 1));
  };

  return (
    <div className={styles.container} role="tab">
      <div className={`${styles['tab-list-wrapper']} ${className || ''}`}>
        <div className={styles['tab-list']}>
          <div className={styles['tab-list-text-container']}>
            {current === 0 && <div className={styles.heading}>{state[0]}</div>}
            {current === 1 && <div className={styles.heading}>{state[1]}</div>}
          </div>
          <div>
            <div className={styles['tab-list-icon-container']}>
              {current === 0 && (
                <Container extensions="cursor-pointer" onClick={toggle}>
                  <Icon icon={icons[1]} size="md" color="quartiary" />
                </Container>
              )}
              {current !== 0 && (
                <Container extensions="cursor-pointer" onClick={toggle}>
                  <Icon icon={icons[0]} size="md" color="quartiary" />
                </Container>
              )}
            </div>
          </div>
        </div>
        <div className={styles.border} />
      </div>

      <div className="w-full">
        {current === 0 && <div className="w-full">{Content && Content[0]}</div>}
        {current === 1 && <div className="w-full">{Content && Content[1]}</div>}
      </div>
    </div>
  );
}

type SCProps = {
  children: any;
};

const Content = (props: SCProps) => props.children;

Content.displayName = 'Content';

IconTab.Content = Content;

export default IconTab;
